export default {
  refreshOn: ({ rows }) => [rows],
  'Table.Table.Header': ({ orderBy, orderDirection }, outlet, internalStateSetter) => {
    const newSortDescriptors = {};
    if (orderBy !== undefined) {
      newSortDescriptors.orderBy = orderBy;
    }
    if (orderDirection !== undefined) {
      newSortDescriptors.orderDirection = orderDirection;
    }
    internalStateSetter(newSortDescriptors);
    outlet({ ...newSortDescriptors, action: 'change_table' });
  },
  'Table.Footer': ({ pageSize, pageNumber }, outlet, internalStateSetter) => {
    internalStateSetter({ pageSize, pageNumber });
    outlet({ pageSize, pageNumber, action: 'change_table' });
  },
  'Table.Table.Body.Row': ({ row, clickable }, outlet) => {
    if (clickable) {
      outlet({ row, action: 'click_row' });
    }
  }
};
